import React from "react";
import { Link as ScrollLink } from "react-scroll";
import logo from "../assets/logo.jpg";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const navItems = [
  //{ title: "Accueil", path: "home" },
  //{ title: "Accompagner", path: "accompagner" },
  //{ title: "Services", path: "services" },
  //{ title: "Tarifs", path: "tarifs" },
];

const footerLinks = [
  { title: "Contactez-Nous", path: "/contact" },
  { title: "CGU / Conditions générales", path: "/conditions-generales" },
  { title: "Signaler un problème", path: "/signaler-probleme" },
  { title: "Politique de confidentialité", path: "/politique-confidentialite" },
  { title: "Mentions légales", path: "/mentions-legales" },
  //{ title: "Aide", path: "/aide" },
  { title: "Devenir partenaire", path: "/devenir-partenaire" },
];

const Footer = () => {
  return (
    <footer className="bg-black text-white pt-10 pb-6 w-full items-center">
      <div className="xl:px-28 px-4">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8">
          {/* Logo & Description */}
          <div className="flex flex-col items-start gap-2 lg:w-1/3 w-full">
            <a href="/">
              <div className="flex items-center gap-2">
                <img
                  src={logo}
                  className="h-full w-auto max-h-20 lg:max-h-28 rounded-lg"
                  alt="THRUNDRZ Logo"
                />
              </div>
            </a>
            <p className="font-archivo text-justify font-medium text-xs">
              THRUNDRZ est une application destinée aux passionnés d’événements et aux créateurs d’événements. Retrouvez facilement les événements autour de vous et donnez de la visibilité à vos propres événements.
            </p>
          </div>

          {/* Raccourcis / Liens */}
          <div className="flex flex-col gap-2">
            <h4 className="font-archivo font-semibold cursor-pointer lg:text-md text-sm hover:text-color6">
              Liens utiles
            </h4>
            {navItems.map((item, index) => (
              <ScrollLink
                key={index}
                to={item.path}
                smooth={true}
                duration={500}
                className="font-archivo font-medium cursor-pointer text-xs underline hover:text-color6"
                spy={true}
                offset={-70}
              >
                {item.title}
              </ScrollLink>
            ))}
            {footerLinks.map((link, index) => (
              <a
                key={index}
                href={link.path}
                className="font-archivo font-medium cursor-pointer text-xs underline hover:text-color6"
              >
                {link.title}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-2">
            <h4 className="font-archivo font-semibold cursor-pointer lg:text-md text-sm hover:text-color6">
              Contactez-nous
            </h4>
            <p className="font-archivo font-medium text-xs hover:text-color6">
              contact@thrundrz.com
            </p>
            <p className="font-archivo font-medium text-xs hover:text-color6">
              Dijon 21000, France
            </p>
          </div>

          {/* Réseaux sociaux */}
          <div className="flex flex-col gap-2">
            <h4 className="font-archivo font-semibold cursor-pointer lg:text-md text-sm hover:text-color6">
              Suivez-nous
            </h4>
            <div className="flex items-center gap-4 pt-2">
              <FaInstagram
                className="cursor-pointer hover:text-color6"
                size={23}
                onClick={() => window.open("https://www.instagram.com/thrundrzteam_/", "_blank")}
              />

              <FaTiktok className="cursor-pointer hover:text-color6" size={23} />
            </div>
          </div>
        </div>

        <hr className="w-full mt-10 border-color2" />

        {/* Copyright */}
        <div className="flex justify-center items-center mt-4">
          <p className="text-xs py-2 font-extralight font-archivo text-color2">
            Copyright © THRUNDRZ {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
